var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2592_10407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0502 21.5011C31.0502 18.6236 28.7176 16.291 25.8402 16.291H10.21C7.33262 16.291 5 18.6236 5 21.5011V28.0136C5 34.4878 10.2484 39.7362 16.7226 39.7362H19.3276C25.8018 39.7362 31.0502 34.4878 31.0502 28.0136V21.5011ZM31.0502 21.5011H33.6553C36.5327 21.5011 38.8653 23.8337 38.8653 26.7111C38.8653 29.5885 36.5327 31.9212 33.6553 31.9212H31.0502",
    stroke: "url(#paint0_linear_2592_10407)",
    strokeWidth: 2.60502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.418 11.0807V0.660645",
    stroke: "url(#paint1_linear_2592_10407)",
    strokeWidth: 2.60502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.627 11.0809V5.87085",
    stroke: "url(#paint2_linear_2592_10407)",
    strokeWidth: 2.60502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2592_10407",
    x1: -14.998,
    y1: 18.4556,
    x2: 113.734,
    y2: 150.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#D82E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4246,
    stopColor: "#E35353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6462,
    stopColor: "#EB6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8429,
    stopColor: "#F07D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#F28322"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2592_10407",
    x1: 14.8275,
    y1: 1.62269,
    x2: 22.5666,
    y2: 2.14839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#D82E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4246,
    stopColor: "#E35353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6462,
    stopColor: "#EB6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8429,
    stopColor: "#F07D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#F28322"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2592_10407",
    x1: 20.0364,
    y1: 6.35187,
    x2: 27.6704,
    y2: 7.38899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#D82E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4246,
    stopColor: "#E35353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6462,
    stopColor: "#EB6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8429,
    stopColor: "#F07D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#F28322"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2592_10407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0 0.276367)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.6100e655bbf017e09f83c913f8e2529a.svg";
export { ForwardRef as ReactComponent };